import {useAppSelector} from "./useAppSelector";
import {UserRole} from "../../shared/models/userRole";

export const useUserRole = (): [UserRole?] => {
    const role = useAppSelector(state => state.user.user?.role);

    return [role];
}
